import { DotLegalInfoDialog } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation";
import { RoleViewModel } from "../Roles.types";
import { useChangeRoleStatusDialog } from "./ChangeRoleStatusDialog.hooks";
import { Trans } from "react-i18next";

export interface IChangeRoleStatusDialog {
    selectedRole: RoleViewModel;
    onCloseDialog: () => void;
    onSave: () => void;
}

export function ChangeRoleStatusDialog(props: IChangeRoleStatusDialog) {
    const { changeActiveStatus, inProgress } = useChangeRoleStatusDialog(props);
    const { translateString } = useTranslation();

    return (
        <DotLegalInfoDialog
            btnText={props.selectedRole.isActive ? translateString("deactivate") : translateString("activate")}
            header={
                props.selectedRole.isActive
                    ? `${translateString("deactivate")}: ${props.selectedRole.name}`
                    : `${translateString("activate")}: ${props.selectedRole.name}`
            }
            inProgress={inProgress}
            content={
                props.selectedRole.isActive ? (
                    <Trans i18nKey="deactivateRole" values={{ name: props.selectedRole.name }}></Trans>
                ) : (
                    <Trans i18nKey="activateRole" values={{ name: props.selectedRole.name }}></Trans>
                )
            }
            onBtnClick={() => changeActiveStatus()}
            onCloseDialog={props.onCloseDialog}
        />
    );
}
